<template>
  <v-content class="content_body scroll-top-bottom" id="passo-5">
    <div class="box-inputs">
      <template>
        <div></div>
      </template>

      <!-- Premiun and Commission -->
      <div class="comissao">
        <h2 class="pt-0 pb-3 headers">Prêmio e Comissão</h2>
        <div class="box-comissao">
          <div class="box-valores-comissao">
            <div class="box-input m-right">
              <p class="label-input">Valor do prêmio</p>
              <v-text-field
                class="jns-input"
                id="emissao_premio_input_valor_premio"
                disabled
                :value="P.toLocaleString('pt-BR', $settings.moneyFormatOptions)"
              ></v-text-field>
            </div>

            <div class="box-input">
              <div class="box-tooltip">
                <p class="label-input">Taxa aplicada</p>
                <v-icon
                  class="icon_blue"
                  @mouseover="showTooltipTax = true"
                  @mouseleave="showTooltipTax = false"
                  >help</v-icon
                >
              </div>
              <div class="msg-tax" v-if="showTooltipTax">
                <p style="text-align: justify">
                  A taxa é o índice que determina a precificação do prêmio do
                  seguro.
                </p>
                <br />
                <p style="text-align: justify">
                  O valor do prêmio é calculado levando-se em conta a seguinte
                  fórmula.
                </p>
                <br />
                <p style="text-align: justify">
                  Valor do Prêmio = (Valor da Importância Segurada * (Taxa /
                  100) * Nro. Dias Vigência Proposta) / 365
                </p>
                <br />
                <p style="text-align: justify">
                  São consideradas para a composição da taxa (e por consequência
                  do prêmio) diversos fatores como: o risco inerente ao negócio,
                  a comissão a ser paga e também a remuneração da seguradora.
                  Por isso, qualquer alteração agravamento em valor do prêmio ou
                  dos percentuais de comissão, geram alteração da taxa.
                </p>
                <br />
                <p style="text-align: justify">
                  A taxa original apresentada é a menor taxa praticada pela
                  seguradora para este risco.
                </p>
                <br />
                <p style="text-align: justify">
                  Qualquer redução abaixo do valor original, será realizada
                  reduzindo-se exclusivamente o percentual de comissão
                </p>
              </div>
              <v-text-field
                class="jns-input"
                id="emissao_premio_input_taxa_aplicada"
                v-model="taxaFormatada"
                :disabled="
                  this.slider.limitType == '$' || !permissao_alterar_portal || Po <= Pmin
                "
                @focus="isInputTaxa = true"
                @blur="
                  isInputTaxa = false;
                  atualiza_valores_pelo_campo_da_taxa();
                "
              ></v-text-field>
              
              <span class="hint">Original {{ Txo }}%</span>
            </div>
          </div>
          <div class="box-valores-pagamento">
            <div class="box-input m-right">
              <p class="label-input">Valor da Comissão</p>
              <v-text-field
                class="jns-input"
                id="emissao_premio_input_valor_comissao"
                :disabled = "true"
                :value="commissionFormatted.toLocaleString('pt-BR', $settings.moneyFormatOptions)"
                @focus="isInputCommissionActive = true"
                @blur="
                  isInputCommissionActive = false;
                  atualiza_valores_pelo_campo_da_comissao();
                "
              ></v-text-field>
            </div>

            <div class="box-input">
              <div class="box-tooltip">
                <p class="label-input">% de comissão</p>
                <v-icon
                  class="icon_blue"
                  @mouseover="showTooltipCommission = true"
                  @mouseleave="showTooltipCommission = false"
                  >help</v-icon
                >
              </div>
              <div class="msg-commission" v-if="showTooltipCommission">
                <p style="text-align: justify">
                  Por padrão, nosso sistema sempre aplica o maior percentual de
                  comissão possível no cálculo da apólice.
                </p>
                <br />
                <p style="text-align: justify">
                  Entretanto, caso o corretor opte por uma diminuição do % da
                  sua comissão em um determinado negócio, ele pode alterar
                  diretamente neste campo.
                </p>
                <br />
                <p style="text-align: justify">
                  Uma vez alterado o % de comissão para um valor abaixo do
                  máximo permitido, o ícone do cadeado ficará fechado indicando
                  que o percentual não irá variar conforme a taxa seja alterada
                  para cima. O cadeado pode ser aberto e a comissão alterada
                  novamente com um simples clique.
                </p>
                <br />
                <p style="text-align: justify">
                  Ao acessar o passo 5, o percentual padrão de comissão do
                  sistema é aplicado.
                </p>
                <br />
                <p style="text-align: justify">
                  Para tomadores com acumulo abaixo de R$ 1,5 milhões (soma de
                  todas as importâncias seguradas ativas já permitidas), o % de
                  comissão será agravado a medida que a taxa for também agravada
                  na seguinte proporção: Para cada +0,1% na taxa, a comissão é
                  agravada em 0,1%. O % máximo de comissão possível é de {{this.Ccmax}}%.
                </p>
                <br />
                <p style="text-align: justify">
                  Em tomadores com acumulo acima de R$ 1,5 milhões, o % máxima
                  será o percentual padrão do sistema, não aumentando a medida
                  que a taxa é agravada.
                </p>
                <br />
                <p style="text-align: justify">
                  Entretanto, mesmo não sendo possível o aumento do % de
                  comissão, o valor absoluto da comissão aumenta a medida que a
                  taxa é agravada.
                </p>
              </div>
              <v-text-field
                v-model="percentualComissaoFormatada"
                class="jns-input"
                id="emissao_premio_input_percentual_comissao"
                readonly
                :disabled="!permissao_alterar_portal || lock_comissao || Po <= Pmin
      "
              ></v-text-field>
              <span class="hint">Máximo {{ Ccmax }}%</span>
            </div>
          </div>
        </div>

        <div class="box-buttons-ajuste">
          <v-btn
            id="emissao_premio_button_valor_comissao"
            class="jns-button jns-button-color fluid-button"
            :class="slider.limitType == '%' ? 'button_nonactive' : ''"
            round
            block
            :disabled="!permissao_alterar_portal"
            @click="onUsingCommission"
            >Ajustar pelo valor da comissão</v-btn
          >

          <v-btn
          id="emissao_premio_button_valor_taxa"
            class="jns-button jns-button-color fluid-button"
            :class="slider.limitType == '$' ? 'button_nonactive' : ''"
            round
            :disabled="!permissao_alterar_portal"
            block
            @click="onUsingTax"
            >Ajustar pelo valor da taxa</v-btn
          >
        </div>

        <div class="box-val-min-max">
          <div class="val-right">
            <span>
              Mínimo
              <br />
              <span
                v-if="this.slider.limitType == '$'"
                v-html="
                  Crminlabel.toLocaleString(
                    'pt-BR',
                    $settings.moneyFormatOptions
                  )
                "
              ></span>
              <span v-if="this.slider.limitType == '%'"
                >{{ parseFloat(Txmin).toFixed(casas_decimais) }}%</span
              >
            </span>

            <span v-if="this.slider.limitType == '$'" class="val-comissao">
              Comissão original
              <br />
              <span
                v-html="
                  Cro.toLocaleString('pt-BR', $settings.moneyFormatOptions)
                "
              ></span>
            </span>
            <span v-else>
              Taxa original
              <br />
              {{ Txo }}%
            </span>
          </div>

          <div class="val-left">
            <span>
              Máximo
              <br />
              <span
                v-if="this.slider.limitType == '$'"
                v-html="
                  Crmax.toLocaleString(
                    'pt-BR',
                    $settings.moneyFormatOptions
                  )
                "
              ></span>
              <span v-if="this.slider.limitType == '%'">{{ Txmax }}%</span>
            </span>
          </div>
        </div>

        <v-layout row wrap>
          <!-- Slider -->
          <v-flex xs12>
            <div class="slider">
              <div class="left_ticks" :style="lengthSliderLimit"></div>

              <div class="right_ticks"></div>

              <v-slider
                v-model="slider.dragger"
                :color="slider.color"
                :thumb-color="slider.color"
                :track-color="slider.track_color"
                thumb-label="always"
                always-dirty
                :disabled="!permissao_alterar_portal || Po <= Pmin"
                :min="slider.min"
                :max="slider.max"
                :step="slider.step"
                @input="atualiza_valores_pelo_slider()"
              ></v-slider>
              <h3 v-if="this.Po <= this.Pmin"Agravamento indisponível para propostas com prêmio mínimo.</h3>
            </div>
            
          </v-flex>
          <!-- ./Slider -->
        </v-layout>
      </div>
      <!-- ./Premiun and Commission -->

      <v-flex xs1 border-right class="line"></v-flex>

      <!-- Payments -->
      <div class="pagamentos">
        <h2 class="pt-0 pb-3 headers">Forma de Pagamento</h2>
        <div class="box-pagamentos">
          <div class="box-parce-fracio">
            <div class="box-input m-right">
              <p class="label-input">Nº de parcelas</p>
              <v-select
                v-model="calculator.parcelNumber"
                :items="disponibleParcels"
                :item-value="'index'"
                :item-text="'description'"
                @input="onSelectParcel()"
                class="jns-input input-parcelas"
                id="emissao_premio_input_numero_parcelas"
                outlined
              ></v-select>
            </div>

            <div class="box-input">
              <p class="label-input">Prazo para pagamento da 1° parcela</p>
              <v-select
                class="jns-input"
                id="emissao_premio_input_prazo_pagamento"
                outlined
                v-model="calculator.paymentDay"
                :items="paymentDays"
                :item-value="'value'"
                :item-text="'text'"
                :selected="7"
              ></v-select>
            </div>
          </div>

          <div class="box-parce-fracio">
            <div class="box-input m-right">
              <p class="label-input">1ª Parcelamento</p>
              <v-text-field
                class="jns-input"
                disabled
                :value="
                  parcela_desconto.toLocaleString(
                    'pt-BR',
                    $settings.moneyFormatOptions
                  )
                "
              ></v-text-field>
            </div>
            <div class="box-input">
              <p class="label-input">Desconto (%)</p>
              <v-select
                v-model="model.tax"
                id="emissao_premio_input_desconto"
                :items="desconto_disponivel"
                :item-value="'index'"
                :item-text="'description'"
                :disabled = "watchLockDescount"
                @input="onChangeDiscount()"
                class="jns-input input-parcelas"
                outlined
              ></v-select>
            </div>
          </div>
          <v-layout row wrap>
            <v-flex v-if="recusada_por_limite" x8>
              <div class="msg_limites">
                <span
                  >Tomador não possui mais Limite de Crédito para realizar a
                  emissão desta Apólice.</span
                >
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <!-- ./Payments -->
    </div>

    <div class="box-button-centered">
      <div class="button-comissao">
        <v-btn
          class="jns-button fluid-button yellow-button"
          id="emissao_premio_button_ajuste_especial"
          @click="onSpecialRequest()"
          >Solicitação especial de ajuste na proposta
        </v-btn>
      </div>

      <div class="buttons-emissao">
        <v-btn class="jns-button width-auto white-button" id="emissao_premio_button_desistir" @click="onDesist()"
          >Desistir</v-btn
        >

        <v-btn
          class="jns-button width-auto"
          id="emissao_premio_button_minuta"
          @click="onGetMinuta()"
          :disabled="recusada_por_limite"
        >
          Ver minuta
          <v-icon>picture_as_pdf</v-icon>
        </v-btn> 

        <v-btn
          class="jns-button width-auto yellow-button"
          id="emissao_premio_button_emitir_apolice"
          @click="onEmitirApolice()"
          :disabled="recusada_por_limite"
        >
          Emitir apólice
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="mensagemMaximoMinimo" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Valor fora do permitido</h2>
        <br />
        <h3 v-if="this.slider.limitType == '$'">
          Valor deve estar entre
          {{ Crmin.toLocaleString("pt-BR", $settings.moneyFormatOptions) }} e
          {{ CrmaxLabel.toLocaleString("pt-BR", $settings.moneyFormatOptions) }}
        </h3>
        <h3 v-if="this.slider.limitType == '%'">
          Valor deve estar entre {{ parseFloat(Txmin).toFixed(3) }}% e
          {{ Txmax }}%
        </h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="mensagemMaximoMinimo = false"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
    <v-dialog v-model="desconto_indisponivel" :max-width="'640'">
      <base-modal >
        <h2 class="headline">Desconto acima do permitido</h2>
        <br />
        <h3>
          Valor minimo da parcela é de {{Pmin.toLocaleString("pt-BR", $settings.moneyFormatOptions)}}
        </h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="desconto_indisponivel = false, model.tax = ''"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import { VMoney } from "v-money";
import axios from "axios";
import config from "@/../config";
import ViewMixin from "@/mixins/ViewMixin";
import { timingSafeEqual } from "crypto";
import { PassThrough } from "stream";
export default {
  name: "PremioComissao",
  mixins: [ViewMixin],
  props: ["idProposta", "idProduto", "proposta"],
  data() {
    return {
      //FIXME:Validar utilização para mascara
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      isInputCommissionActive: false,
      development: true,
      moneyConfig: {},
      paymentDays: ["7"],
      showTooltipTax: false,
      showTooltipCommission: false,
      lock_icon: "lock_open",
      lock_icon_values: {
        open: "lock_open",
        close: "lock",
      },
      agravamento: false,
      slider: {
        dragger: 0,
        min: 0,
        max: 0,
        limit: 0,
        limitType: "$",
        color: "#282498",
        track_color: "gray",
        step: 0.1,
        original: this.Cco,
        update: false,
      },
      //TODO: Remover todas as va
      calculator: {
        commission: 0,
        commissionPercentual: 0,
        appliedTax: 0,
        premium: 0,
        originalCommission: 0,
        originalCommissionTax: 0,
        originalCommissionPercentual: 0,
        originalAppliedTax: 0,
        originalPremium: 0,
        aggravation: 0,
        fixedAggravationCompare: 50,
        /* Payment values */
        parcelNumber: 0,
        additional_fractionation: 0,
        first_parcel: 0,
        paymentDay: 7,
      },
      parcels: [],
      desconto_disponivel: [''],
      model: {
        tax: 0
      },
      disponibleParcels: [],
      fractionation: 0, // Fracionamento
      PARCEL_MIN_VAL: 1500,
      PREMIUM_PARCELLATION_CUT: 20000,
      relevant_serasa: false,
      isCommissionSeted: false,
      isInputTaxa: false,
      commissionMaximumLimit: 0,
      mensagemMaximoMinimo: false,
      recusada_por_limite: false,
      desconto_indisponivel: false,
      desconto_lock : false,
      alterar_comissao: true,
      /*fixeMaxTax: 15,
      minTax: 15, //TODO: Setar valores
      maxTax: 41, //TODO: Setar valores,
      aggravationCommissionPercent: 0.5, //Agravamento em comissão percentual,
      aggravationTax: 0.1, // Agravamento na taxa,
      maxCommissionPercent: 41, // Comissao do corretor maxima
      commissionPercentTemp: 15, // Valor temporario para o caso do cadeado
      minPremium: 160, //Premio minimo aceito pela i4pro*/

      /* Payment values */
      parcelNumber: 0,
      additional_fractionation: 0,
      first_parcel: 0,
      paymentDay: 7,
      /* Variveis de cálculos */
      Po: 0, //Premio original
      Txo: 0, //Taxa original
      Cro: 0, //Comissão em reais
      Cco: 0, // Comissão corretor ou percentual de commissão
      cct: 15, //Valor temporario para o caso do cadeado
      Pmin: 160, //Premio minimo aceito pela i4pro
      Txmax: 100, //Valor minimo e maximo da taxa em relacao ao slider
      Txmin: 0, //No caso de Txmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      atx: 0.5, //Agravamento em tx,
      acc: 0.5, //Agravamento em cc,
      Ccmax: 41, //Comissao do corretor maxima
      Cr: 0, //Comissão
      P: 0, // Prêmio
      importancia_segurada: 0,
      dias_vigencia: 0, // data de vigencia da proposta (em dias)
      Tx: 0, // Taxa
      Cc: 0, // % comissão
      So: 15, // Quando o slider estiver em 20% os valores terao quer ser os originais
      A: 0, //Fator que e combinacao de acc e atx
      Crmax: 0, // Comissão máxima
      Crmin: 0, // Comissão minima
      Crminlabel: 0,
      lock_desconto: false,
      disable_slider: false,
      permissao_alterar_portal: true,
      CrmaxLabel: "",
      casas_decimais: 4,
      Ccmin: 1, // Percentual de comissão do correto minimo
      parcela_desconto: 0,
      taxa_parcela: 0,
      lock_comissao: false,
      red_line: 0,
      recebe_desconto: false,
    };
  },
  directives: { money: VMoney },
  computed: {
    commissionFormatted: {
      get: function () {
        if (this.isInputCommissionActive) {
          return this.Cr.toString();
        } else {
          let commission = this.Cr.toString().replace(",", ".");

          return parseFloat(commission).toLocaleString(
            "pt-BR",
            this.$settings.moneyFormatOptions
          );
        }
      },
      set: function (newValue) {
        let commission = newValue
          .toString()
          .replace(",", ".")
          .replace(/[^0-9\.]/g, "")
          .replace("R$", "");

        this.Cr = Number(commission);
      },
    },
    watchLockDescount() {
      if (!this.permissao_alterar_portal || this.Tx > this.Txo || this.lock_desconto) {
        return true
      }
      return false
    },
    lengthSliderLimit() {
      if (this.slider.limitType == "%") {
        let dashedLimit = this.red_line * 0.45051

        return `width:${dashedLimit}%`;
      } else {
        let dashedLimit = (this.red_line + this.Cco) / this.Ccmax * 45.5
        return `width:${dashedLimit}%`;
      }
    },
    taxaFormatada: {
      get: function () {
        if (this.isInputTaxa) {
          let taxa = this.Tx.toString().replace(",", ".");
          return this.formatValue(taxa);
        } else {
          return this.formatValue(this.Tx);
        }
      },
      set: function (newValue) {
        this.Tx = newValue;
      },
    },
    percentualComissaoFormatada: {
      get: function () {
        return this.formatValue(this.Cc);
      },
      set: function (newValue) {
        this.Cc = newValue;
      },
    },
  },
  methods: {
    /* Initializes */
    definePaymentDays() {
      this.paymentDays = [];
     let initial = this.proposta.dia_minimo_vencimento;
      let limit =  this.proposta.dia_maximo_vencimento;

      for (let index = initial; index <= limit; index++) {
        this.paymentDays.push({ text: index.toString(), value: index });
      }
    },

    getTaxaAtualizada(){
      let taxa = 0;
      if (this.slider.limitType == '%'){
        taxa = this.slider.dragger 
      }
      else {
       taxa = this.slider.dragger / this.Cco

      }
      return taxa
    },
    async getTomadorAcumulo() {
      var varId = this.proposta.id_tomador

      let acumuloInfo;
      try {
        this.showLoadingAskWait();
        acumuloInfo = await this.$store.dispatch("GET_GRUPO_ACUMULO", {
          id: varId,
        });
      }finally {
        this.hideLoadingAskWait();
      }
      let acumulo_filtrado = acumuloInfo[0]['valor_total_acumulado']
      if((acumulo_filtrado + this.importancia_segurada) >= 1500000){
        this.lock_comissao = true
      }
    return acumuloInfo
  },

    defineOriginalValues() {
      if (this.proposta) {
        //this.getTomadorAcumulo();
        try {
          this.Cco = this.proposta.comissao_percentual_passo5;
          this.Cc = this.Cco;
          this.cct = this.Cco;
          this.Cro = this.proposta.comissao_reais_passo5;
          this.Cr = this.Cro;
          this.Txo = this.proposta.taxa_passo5;
          this.Tx = this.Txo;
          this.Po = this.proposta.premio_passo5;
          this.P = this.Po;
          this.parcela_desconto = this.Po
          this.Pmin = this.proposta.premio_minimo_passo5;
          this.dias_vigencia = this.proposta.dias_vigencia
          this.importancia_segurada = this.proposta.importancia_segurada
          this.red_line = this.Pmin / (this.importancia_segurada * (this.dias_vigencia / 365) / 100)
          this.PARCEL_MIN_VAL = this.proposta.valor_minimo_parcela

          if (this.Po <= this.Pmin){
            this.red_line = 0
          }

          this.agravamento = this.proposta.agravamento_passo5;
          if (this.agravamento == false)
            this.lock_icon = this.lock_icon_values.close;

          this.permissao_alterar_portal = this.proposta.permissao_alterar_portal;
          this.relevant_serasa = this.proposta.tomador_serasa_relevante;

          this.recusada_por_limite = this.proposta.recusada_por_limite;
        } catch (error) {}
      }
    },
    defineCommissionSliderValues() {
      this.slider.limitType = "$";
      this.slider.min = 0;
      this.slider.max = this.Ccmax;
      this.slider.limit = this.calculateLimit();
      this.slider.update = true;
      this.slider.dragger = this.Cco;
      this.slider.dragerDesconto = 0;
      this.calcularFatorCombinacao();
      this.calcularComisaoMaxima();
      this.calcularComissaoMinima();
      this.calcularComissaoMaximaLabel();
    },
    defineParcels() {
      if (this.proposta.produto_parcelamentos != null) {
        this.parcels = [];
        let index = 0;
        this.proposta.produto_parcelamentos.forEach((item) => {
          let parcel = {
            index: index,
            parcelId: item.id_produto_parcela,
            description: item.descricao,
            parcelNumbers: item.numero_parcelas,
            interests: item.juros,
          };

          this.parcels.push(parcel);
        });

        this.parcels.sort(function (a, b) {
          return a.parcelNumbers - b.parcelNumbers;
        });
      }
    },
    defineCommissionMaxValue() {
      this.commissionMaximumLimit = 0;

      let maximumValue =
        (this.calculator.originalPremium * Ccmax) /
        this.calculator.originalAppliedTax;

      this.commissionMaximumLimit = (maximumValue * this.fixeMaxTax) / 100;
    },

    /* Emiters */
    emitProposalValues() {
      if (this.calculator.parcelNumber == null) return null;

      let selectedParcel = this.parcels.find(
        (p) => p.index == this.calculator.parcelNumber
      );
      if (selectedParcel) {
        let proposalParcels = [
          {
            id_parcelamento: selectedParcel.parcelId,
            premio_total: Number(this.P),
            nr_parcela: selectedParcel.parcelNumbers,
            qt_total: Number(this.parcela_desconto),
            vl_adicional:
              this.calculator.additional_fractionation /
              Number(selectedParcel.parcelNumbers),
          },
        ];

        let proposalCoverages = [];
        if (this.proposta.coberturas.length == 1) {
          let coverage = this.proposta.coberturas[0];
          proposalCoverages = [
            {
              id: Number(coverage.id),
              premio: Number(this.P),
            },
          ];
        } else {
          let sum = this.proposta.coberturas.reduce(
            (a, b) => a + (b["premio"] || 0),
            0
          );

          this.proposta.coberturas.forEach((coverage) => {
            let percent = (coverage.premio * 100) / sum;
            let premium = (this.P * percent) / 100;

            proposalCoverages.push({
              id: Number(coverage.id),
              premio: Number(premium),
            });
          });
        }
        if (this.model.tax == '') {
          this.model.tax = 0
        }
        const postData = {
          id_proposta: Number(this.idProposta),
          id_produto: Number(this.idProduto),
          taxa_risco: this.Tx,
          comissao_corretor: this.Cc,
          quantidade_parcelas: Number(selectedParcel.parcelNumbers),
          dias_primeira_parcela: Number(this.calculator.paymentDay),
          comissao_reais: this.Cr,
          agravamento: this.agravamento,
          coberturas: proposalCoverages,
          parcelamento: proposalParcels,
          desconto_premio: this.model.tax,
        };
        
                        this.$emit("emitProposalValues", postData);
      }
    },

    emitGetMinuta() {
      this.$emit("getMinuta");
    },


    /* Utils */
    formatValue(value) {
      try {
        return parseFloat((value).toFixed(this.casas_decimais));
      } catch (error) {
        return 0;
      }
    },

    /* Parcels */
    calculateAdditionalFractionation(premium, interests, parcelNumbers) {
      if (parcelNumbers == 1) return 0;

      if (premium == null) premium = 0;

      if (interests == null) interests = 0;

      if (parcelNumbers == null) parcelNumbers = 0;

      try {
        let x = (1 + parseFloat(interests)) ** (parseFloat(parcelNumbers) - 1);
        let numerator =
          parseFloat(premium) * parseFloat(interests) * parseFloat(x);
        let denominator =
          parseFloat(x) - 1 + parseFloat(interests) * parseFloat(x);
        let division = parseFloat(numerator) / parseFloat(denominator);

        return (
          parseFloat(division) * parseFloat(parcelNumbers) - parseFloat(premium)
        );
      } catch (error) {
        console.error(
          "Não foi possível calcular o adicional de fracionamento. erro: " +
            error
        );
        return 0;
      }
    },
    calculateParcelValues() {
      this.disponibleParcels = [];

      if (this.relevant_serasa) {
        let parcel = this.parcels[0];
        this.setParcelValues(0);
        parcel.index = 0;
        parcel.additional_fractionation = 0;
        parcel.value = this.P;
        this.calculator.first_parcel = parcel.value;
        this.disponibleParcels.push(parcel);
        return;
      }

      for (let i = 0; i < this.parcels.length; i++) {
        try {
          let parcel = this.parcels[i];
          let parcelNumbers = parcel.parcelNumbers;
          let interests = parseFloat(parcel.interests) / 100;
          let additional_fractionation = 0;
          if (interests > 0) {
            additional_fractionation = this.calculateAdditionalFractionation(
              this.P,
              interests,
              parcelNumbers
            );
          }

          let parcelValue =
            parseFloat(this.P + additional_fractionation) / parcelNumbers;

          let additional_fractionation_parcel =
            parseFloat(additional_fractionation) / parcelNumbers;

          let totalPremiun =
            parseFloat(this.P) + parseFloat(additional_fractionation);


          let parcelaFormatada = Number(parcelValue.toFixed(4))
          if (parcelNumbers >= 2) {
            
            if (parcelaFormatada < this.PARCEL_MIN_VAL) continue;
          }

          if (parcelNumbers >= 4) {
            if (
              parseFloat(this.P) < parseFloat(this.PREMIUM_PARCELLATION_CUT) &&
              interests == 0
            )
              continue;
          }

          parcel.index = i;
          parcel.additional_fractionation = additional_fractionation;
          parcel.value = parcelValue;
          
          this.disponibleParcels.push(parcel);
        } catch (error) {
          console.error("Erro ao calcular as parcelas. Erro: " + error);
        }
      } // ./ End For
      
      this.setParcelValues(0);
    },
    setParcelValues(parcelNumber) {
      let selectedParcel = this.parcels.find((p) => p.index == parcelNumber);
      if (selectedParcel) {
        this.calculator.additional_fractionation =
          selectedParcel.additional_fractionation != null
            ? selectedParcel.additional_fractionation
            : 0;
        this.calculator.first_parcel =
          selectedParcel.value != null ? selectedParcel.value : 0;
      }
    },

    /* Screen events */
    onLock() {
      if (this.agravamento) {
        if (this.lock_icon_values.open == this.lock_icon) {
          // Aberto
          this.lock_icon = this.lock_icon_values.close;

          //FIXME: Rever este calculo
          //this.Cr = (this.Txmax / this.Txo) * this.Po * this.cct / 100;
        } else {
          // Fechado
          this.lock_icon = this.lock_icon_values.open;
          this.Crmax =
            ((this.Txmax * this.Cco +
              this.A * this.Txmax ** 2 -
              this.A * this.Txmax * this.Txo) *
              this.Cro) /
            (this.Txo * this.Cco);
        }

        this.calcularComissaoMaximaLabel();
      } else {
        this.lock_icon = this.lock_icon_values.close;
      }
    },
    onUsingCommission() {
      this.calculateDescountValues();
      this.defineOriginalValues();
      this.defineCommissionSliderValues();
      this.slider.step = 0.1;
      this.slider.limitType = "$";
      if (this.agravamento) this.lock_icon = this.lock_icon_values.open;
      this.calculateParcelValues();
      this.resetParcelsDiscount()
    },
    onUsingTax() {
      this.calculateDescountValues();
      this.defineOriginalValues();
      this.slider.min = this.Txmin;
      this.slider.max = 100;
      this.slider.limit = this.calculator.originalAppliedTax;
      this.slider.update = true;
      this.slider.dragger = this.Txo

      this.slider.limitType = "%";
      this.slider.step = 0.01;
      this.calculateParcelValues();
      this.calcularTaxaMinima();
      this.resetParcelsDiscount()
      if (this.agravamento) this.lock_icon = this.lock_icon_values.open;
    },
    resetParcelsDiscount() {
      this.calculator.parcelNumber = 0
      this.atualiza_valores_desconto();
      this.calculateParcelValues();
      this.calculateDescountValues();

    },
    onChangeDiscount() {
      this.atualiza_valores_desconto();
      this.calculateParcelValues();

    },
    onSelectParcel() {
      this.calculateDescountValues()
      this.setParcelValues(this.calculator.parcelNumber);
      this.atualiza_valores_desconto();
    },
    onSpecialRequest() {
      this.$emit("showQuestionamento");
    },
    onDesist() {
      this.$emit("desistir");
    },
    onEmitirApolice() {
      this.emitProposalValues();
      this.$emit("abrirModalTermosAceite");
    },

    onGetMinuta() {
      this.emitProposalValues();
      this.$emit("emitGetMinuta");
    },

    /* Calculators */

    calculateLimit() {
      if (this.slider.limitType == "$") {
        return this.calculator.originalCommission;
      } else {
        return this.calculator.originalAppliedTax;
      }
    },

    calcularTaxaMinima() {
      // No caso de Txmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      this.Txmin = parseFloat((this.Pmin * this.Txo) / this.Po).toFixed(2)
      if (this.Po - this.Cro < this.Pmin)
        this.Txmin = parseFloat((this.Pmin / this.Po) * this.Txo).toFixed(2);
    },

    calcularComisaoMaxima() {
      //# Calculando o valor de Crmax para o cadeado aberto
      let taxa_maxima = this.Txo + (this.Ccmax - this.Cco)
      let premio_max = this.importancia_segurada * (taxa_maxima /100) * (this.dias_vigencia / 365)
      this.Crmax = premio_max * (this.Ccmax / 100)
      // this.Crmax =
      //   ((this.Txmax * this.Cco +
      //     this.A * this.Txmax ** 2 -
      //     this.A * this.Txmax * this.Txo) *
      //     this.Cro) /
      //   (this.Txo * this.Cco);
    },

    calcularComissaoMinima() {
      //# No caso de Crmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      this.Crmin = 0;
      if (this.Po - this.Cro < this.Pmin)
        this.Crmin = this.Cro - (this.Po - this.Pmin);

      this.Crminlabel = this.Crmin;
      if (this.Crmin == 0) {
        this.calcularTaxaMinima();
        this.Crminlabel =
          (this.Pmin * (this.Cco - (this.Txo - this.Txmin))) / 100;
      }
    },

    calcularComissaoMaximaLabel() {
      if (this.lock_icon == this.lock_icon_values.close) {
        this.CrmaxLabel = ((this.Txmax / this.Txo) * this.Po * this.cct) / 100;
      } else {
        this.CrmaxLabel =
          ((this.Txmax / this.Txo) * this.Po * this.Ccmax) / 100;
      }
    },

    calcularFatorCombinacao() {
      //# Fator que e combinacao de acc e atx
      this.A = (this.acc) / this.atx;
    },

    /* Using tax */
    atualiza_valores_taxa(taxa) {
      // Metodo que atualiza os valores
      //Premio so depende da taxa
      let comissao_corretor = 0;
      let novo_premio = this.importancia_segurada * (taxa/100) * (this.dias_vigencia/365)

      //A proporção de taxa/comissao é 1/3
      let agravo = (((taxa - this.Txo) / this.Txo) / 3) * this.Cco

      comissao_corretor = this.Cco + agravo

      if (comissao_corretor > this.Ccmax) {
        comissao_corretor = this.Ccmax
       }
      
      if (this.lock_comissao) {
        comissao_corretor = this.Cc
      }

      let comissao_reais = novo_premio * comissao_corretor / 100

      if (novo_premio >= this.Pmin) {
      comissao_reais = novo_premio * comissao_corretor / 100
      }
      else {
        comissao_corretor = this.Cco
        taxa = this.Txo
        novo_premio = this.Pmin
        comissao_reais = novo_premio * comissao_corretor / 100
      }

      this.parcela_desconto = novo_premio / (this.calculator.parcelNumber + 1)
      // //Calculando os valores para a regiao acima do original
      // if (taxa >= this.Txo) {
      //   comissao_corretor = this.calcula_comissao_corretor(taxa);
      //   comissao_reais = (premio * comissao_corretor) / 100;
      // } else{
      //   comissao_reais = this.Po * (taxa / this.Txo) - (this.Po - this.Cro);
      //   comissao_corretor = (100 * comissao_reais) / premio;
      //   if (comissao_corretor < this.Ccmin) {
      //     comissao_corretor = this.Ccmin;

      //     comissao_reais = (premio * comissao_corretor) / 100;
      //   }
      // }

      this.atualiza_valores_na_tela(
        taxa,
        novo_premio,
        comissao_reais,
        comissao_corretor
      );

      this.atualiza_valores_desconto();
    },



    atualiza_valores_comissao(comissao) {
      //   """ Metodo que atualiza os valores """
      //# Premio so depende da taxa
      let comissao_reais = this.Cro
      let taxa = this.Txo
      let valor_slider = parseFloat(this.slider.dragger)
      let comissao_corretor = valor_slider
      let novo_premio = this.Po;
      let importancia_segurada = this.importancia_segurada
      let dias_vigencia = this.dias_vigencia
      let taxa_minima = 0;

      // A taxa cresce 3 vezes mais a comissão

      let agravo = (((valor_slider - this.Cco)/this.Cco) * 3) * this.Txo
      taxa = this.Txo  + agravo  

      novo_premio = importancia_segurada * (taxa/100) * (dias_vigencia/365)
      taxa_minima = (this.Pmin * this.Txo) / this.Po
      //caso a regra de comissao se aplique tenho que mduar aqui
      if (taxa < taxa_minima){
        taxa = taxa_minima
        novo_premio = this.Pmin
        comissao_reais = novo_premio * comissao_corretor / 100
      }

      if (novo_premio >= this.Pmin) {
        comissao_reais = novo_premio * comissao_corretor / 100
      }
      else {
        taxa = this.Txo
        novo_premio = (this.Pmin)
        comissao_corretor = this.Cco
        comissao_reais = novo_premio * comissao_corretor / 100
      }

      if (this.lock_comissao) {
        comissao_corretor = this.Cc
        comissao_reais = novo_premio * comissao_corretor / 100
      }

      this.parcela_desconto = novo_premio / (this.calculator.parcelNumber + 1)
      // //# Calculando os valores para a regiao acima do original
      // if (comissao >= this.Cro) {
      //   //calcula os valores do comissao do corretor e comissao em reais acima do original
      //   comissao_corretor = this.calcula_comissao_corretor(taxa);
      //   //# A comissao em reais depende do premio e da comissao do corretor
      //   comissao_reais = (premio * comissao_corretor) / 100;
      //   console.log(comissao_reais, comissao_corretor)
      // } else {
      //   //calcula os valores do comissao do corretor e comissao em reais abaixo do original
      //   // # Como nao tem agravamento para valores abaixo do original e foi utilizado Po = ((Po - Cro) / Po) * Txo
      //   //# para passar pelo minimo entao Cr = (Tx / Txo) * Po - (Po - Cro)
      //   comissao_reais = comissao;
      //   taxa = ((comissao + (this.Po - this.Cro)) / this.Po) * this.Txo;
      //   premio = (taxa / this.Txo) * this.Po;
      //   comissao_corretor = (100 * comissao_reais) / premio;
      //   if (comissao_corretor < this.Ccmin) {
      //     this.calcularTaxaMinima();
      //     premio = (this.Txmin / this.Txo) * this.Po;
      //     comissao_corretor = this.Ccmin;
      //     comissao_reais = (premio * comissao_corretor) / 100;
      //   }
      // }



      this.atualiza_valores_na_tela(
        taxa,
        novo_premio,
        comissao_reais,
        comissao_corretor
      );

      this.atualiza_valores_desconto();
    },
    watchDescountValue() {
      let desconto_bloqueado = this.watchLockDescount
      if (desconto_bloqueado){
        this.model.tax = ''
        return 0
      }
      
      return this.model.tax / 100
    },

  
    atualiza_valores_desconto(){
      let taxa_desconto = this.watchDescountValue()
      let taxa = this.getTaxaAtualizada()
      let numero_parcelas = this.calculator.parcelNumber + 1
      let premio = (this.importancia_segurada * (taxa/100) * (this.dias_vigencia/365)) - (this.Po * taxa_desconto)
      let parcela = Number((premio / numero_parcelas).toFixed(4))
      //Impede desconto na parcela se o valor descontado for abaixo do minimo
      if (numero_parcelas > 1 && parcela < this.PARCEL_MIN_VAL){
        this.calculator.parcelNumber = 0
        numero_parcelas = 1
        this.lock_desconto = true
        this.P = this.Po
        this.parcela_desconto = (this.Po / numero_parcelas)
        return
      }
      //somente se não ocorrer agravamento é possivel aplicar desconto
      if (this.Tx <= this.Txo) {
     
      this.P = this.Po - (this.Po * taxa_desconto)
      this.Tx = (this.P * this.Txo) / this.Po 
      this.Cr = this.P * (this.Cc/100)
      
    }

    this.parcela_desconto = this.P / numero_parcelas

      },
    calculateDescountValues(){
      this.desconto_disponivel = [''];
      let premio = 0;
      let parcela = 0;
      let i = 0;
      for (i = 1; i < 21; i++) {
        premio = this.Po - (this.Po * i / 100)
        parcela = premio / (this.calculator.parcelNumber + 1)
        if (premio > this.Pmin) {
          this.desconto_disponivel.push(i)
        }
      }
    },
    calcula_premio(taxa) {
      //""" Metodo que calcula o premio """
      return (taxa / this.Txo) * this.Po;
    },

    calcula_comissao_corretor(taxa) {
      //""" Metodo que calcula a comissao do corretor com agravamento """

      //# Se o cadeado estiver aberto entao agravar a comissao do corretor
      let agravamento = 0;
      if (this.lock_icon == "lock_open") agravamento = taxa - this.Txo;

      let cc = this.Cco + (this.acc * agravamento) / this.atx;

      //# Verificando se a comissao agravada superou o maximo permitido
      if (cc > this.Ccmax) cc = this.Ccmax;

      if (this.lock_icon == "lock_open") this.cct = cc;

      return this.cct;
    },
    calcula_premio_comissao(comissao) {
      //""" Metodo que calcula o premio """
      //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);

      return (taxa / this.Txo) * this.Po;
    },
    calcula_taxa_comissao(comissao) {
      //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);
      return taxa;
    },

    slider_to_taxa(slider_valor) {
      /*Metodo que calcula o valor da taxa a partir do slider*/

      // Valor do slider
      let s = parseFloat(slider_valor);
      let taxa = 0;

      //Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //Convertendo o valor do slider para a taxa quando este <= So
      if (s <= this.So) { 
        taxa =
          this.Txmin +
          (s - this.slider.min) *
            ((this.Txo - this.Txmin) / (this.So - this.slider.min));
        }
      else
        taxa =
          this.Txo +
          (s - this.So) *
            ((this.Txmax - this.Txo) / (this.slider.max - this.So));

      return taxa;
    },

    taxa_to_slider(taxa) {
      //""" Metodo que calcula o valor do slider a partir da taxa"""
      let s = 0;
      if (taxa <= this.Txo) {
        s =
          ((taxa - this.Txmin) * (this.So - this.slider.min)) /
            (this.Txo - this.Txmin) +
          this.slider.min;
      } else {
        s =
          ((taxa - this.Txo) * (this.slider.max - this.So)) /
            (this.Txmax - this.Txo) +
          this.So;
      }

      return s;
    },

    slider_to_comissao(slider_valor) {
      //""" Metodo que calcula o valor da comissao a partir do slider """

      //# Valor do slider
      let s = parseFloat(slider_valor);
      let comissao = 0;
      //# Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //# Convertendo o valor do slider para a comissao quando este <= So
      if (s <= this.original) {
        comissao =
          this.Crmin +
          (s - this.slider.min) *
            ((this.Cro - this.Crmin) / (this.So - this.slider.min));
      } else {
        comissao =
          this.Cro +
          (s - this.So) *
            ((this.Crmax - this.Cro) / (this.slider.max - this.So));
      }
      return comissao;
    },

    comissao_to_slider(comissao) {
      //""" Metodo que calcula o valor do slider a partir da comissao"""
      let s = 0;
      if (comissao <= this.Cro) {
        s =
          ((comissao - this.Crmin) * (this.So - this.slider.min)) /
            (this.Cro - this.Crmin) +
          this.slider.min;
      } else {
        s =
          ((comissao - this.Cro) * (this.slider.max - this.So)) /
            (this.Crmax - this.Cro) +
          this.So;
      }
      return s;
    },

    /* Update screen fields */
    atualiza_valores_na_tela(taxa, premio, comissao_reais, comissao_corretor) {
      // Atualiza os valores da tela
      this.P = premio;
      this.Tx = taxa;
      this.Cr = comissao_reais;
      this.Cc = comissao_corretor;
      this.commissionFormatted = this.Cr;
    },

    atualiza_valores_pelo_campo_da_taxa() {
      // Metodo que atualiza os valores da simulacao pelo campo da taxa
      try {
        let taxa = parseFloat(this.Tx);
        if (
          parseFloat(Number(taxa).toFixed(6)) >=
            parseFloat(Number(this.Txmin).toFixed(6)) &&
          parseFloat(Number(taxa).toFixed(6)) <=
            parseFloat(Number(this.Txmax).toFixed(6))
        ) {
          let s = this.taxa_to_slider(taxa);
          this.slider.update = false;
          this.slider.dragger = taxa;

          this.atualiza_valores_taxa(taxa);

          this.calculateParcelValues();
        } else {
          this.mensagemMaximoMinimo = true;
        }
      } catch (error) {}
    },

    // atualiza_valores_pelo_campo_da_comissao() {
    //   //""" Metodo que atualiza os valores da simulacao pelo campo da comissao """
      
    //   let premio_maximo = 0;
    //   let comissao_reais = 0;
    //   let premio = 0;
    //   let taxa = 0;
    //   let comissao_corretor = 0;


    //   if (this.Cr > this.Crmax) {
    //     console.log("erro")
    //   }
    //   else{
    //     comissao_reais = this.Cr
    //     premio = this.calcula_premio_comissao(comissao_reais)
    //     comissao_corretor = this.Cc
    //     taxa = this.Txo + (this.Cc - this.Cco)    
        
    //     console.log(comissao_reais, premio, comissao_corretor, taxa)
    //   }
      

    //   try {
    //     let comissao = parseFloat(this.Cr); // Comissão digitada
    //     let taxa = 0;
    //     if (this.lock_icon == "lock_open") {
    //       let a = this.A;
    //       let b = this.Cco - a * this.Txo;
    //       let c = (-100 * comissao * this.Txo) / this.Po;
    //       let taxa1 = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);
    //       let taxa2 = (100 * comissao * this.Txo) / (this.Po * this.Ccmax);
    //       taxa = Math.max(taxa1, taxa2);
    //     } else {
    //       taxa = (100 * comissao * this.Txo) / (this.Po * this.cct);
    //     }

    //     let premio = (taxa / this.Txo) * this.Po;
    //     let agravamento = taxa - this.Txo;
    //     let cc = this.Cco + (this.acc * agravamento) / this.atx;
    //     // if (cc < this.Ccmin) {
    //     //   cc = this.Ccmin;
    //     // }
    //     let comissao_corrigida = (premio * cc) / 100;

    //     if (
    //       parseFloat(comissao_corrigida).toFixed(3) >= this.Crmin &&
    //       parseFloat(comissao_corrigida).toFixed(3) <= this.Crmax
    //     ) {
    //       let s = this.comissao_to_slider(comissao_corrigida);
    //       this.slider.update = false;
    //       this.slider.dragger = s;
    //       this.atualiza_valores_comissao(comissao_corrigida);
    //     } else {
    //       this.mensagemMaximoMinimo = true;
    //     }
    //   } catch (error) {}
    //   this.calculateParcelValues();
    // },

    /* Move the slider */

    // when moving slider calculate values
    atualiza_valores_pelo_slider() {

      if (this.slider.dragerDesconto){
        let valor_desconto = this.slider.dragerDesconto

      }
      //desconto do premio

      if (this.slider.update) {
        let valor = this.slider.dragger;

        // Metodo que atualiza os valores da simulacao pelo slider

        // by tax
        if (this.slider.limitType == "%") {
          //Calculando o valor da taxa a partir do slider
          let taxa = this.slider_to_taxa(valor);
          this.atualiza_valores_taxa(this.slider.dragger);
        } else {
          // Calculando o valor da comissão a partir do slider
          let comissao = this.slider_to_comissao(valor);
          this.atualiza_valores_comissao(comissao);
        }

        //Recalcular parcelas e emitir valores para proposta
        this.calculateParcelValues();
      }
      this.resetParcelsDiscount()
      this.slider.update = true;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getTomadorAcumulo();
    this.defineOriginalValues();
    this.defineCommissionSliderValues();
    this.definePaymentDays();
    this.defineParcels();
    this.calculateParcelValues();
    this.moneyConfig = this.$settings.moneyConfig;
    this.calculateDescountValues();
    this.model.tax = ''
    this.$forceUpdate();
  },
};
</script>

<style lang='scss' scoped>
#jns {
  $blueColor: #282498;
  $whiteColor: #ffffff;

  .box-inputs {
    display: flex;
    width: 100%;
    height: 100%;

    .comissao,
    .pagamentos {
      display: flex;
      flex-direction: column;
      width: 50%;
    }

    @media screen and (max-width: 1280px) {
      .comissao,
      .pagamentos {
        margin-top: 3rem;
      }

      .box-buttons-ajuste {
        flex-direction: column;

        .jns-button {
          margin: 0 0 2rem 0;
          padding: 10px !important;
        }
      }
    }

    @media screen and (max-width: 1000px) {
      .comissao,
      .pagamentos {
        .box-comissao,
        .box-pagamentos {
          .box-valores-comissao,
          .box-valores-pagamento,
          .box-parce-fracio {
            flex-direction: column;
          }

          .box-input {
            margin: 0 !important;
          }
        }
      }

      .pagamentos {
        margin-bottom: 200px;
      }

      .box-buttons-ajuste {
        .jns-button {
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 745px) {
    .box-inputs {
      flex-direction: column;

      .line {
        display: none;
      }

      .comissao,
      .pagamentos {
        width: 100%;
      }

      .box-buttons-ajuste {
        .jns-button {
          font-size: 0.875rem;
        }
      }
    }
  }

  .box-comissao,
  .box-pagamentos {
    display: flex;
    width: 100%;
    flex-direction: column;

    .box-valores-comissao,
    .box-valores-pagamento,
    .box-parce-fracio {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin: 0 0 1.2rem 0;
    }

    .m-right {
      margin-right: 2rem;
    }

    .box-input {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100px;

      .box-tooltip {
        display: flex;

        .v-icon {
          margin: 0 0 0 5px !important;
        }
      }

      .label-input {
        position: inherit;
        margin: 0 !important;
        color: #172c52 !important;
        font-weight: bold;
        font-size: 14px !important;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .v-input {
      margin: 0 !important;
      padding: 0;
    }

    .hint {
      margin: 0;
      padding: 0;
    }
  }

  .input-parcelas {
    width: 100%;
  }

  .box-button-centered {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    :nth-child(2) {
      margin-left: 2rem;
    }
  }
  
  .box-buttons-ajuste {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    :nth-child(2) {
      margin-left: 2rem;
    }
  }

  .box-val-min-max {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 1rem;
    font-size: 13px;

    .val-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      flex: 1;
    }

    .val-right {
      display: flex;
      flex-direction: row;
      width: 35%;
      justify-content: space-between;

      .val-comissao {
        color: gray;
      }
    }
  }

  .box-button-fixed {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #f5f5f5;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 32px;

    .button-comissao {
      display: flex;
      width: 50%;
      align-items: center;
      justify-content: center;
      overflow: hidden !important;

      .jns-button {
        width: 90% !important;
        text-overflow: ellipsis;
        overflow: hidden !important;
      }
    }

    .buttons-emissao {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  @media screen and (max-width: 1000px) {
    .box-button-fixed {
      flex-wrap: wrap;
      display: 100%;

      .button-comissao {
        width: 100%;
        margin: 0 !important;
        padding: 0;

        .jns-button {
          font-size: 1rem;
          width: 100% !important;
        }
      }

      .buttons-emissao {
        flex-direction: column;
        width: 100%;

        .jns-button {
          font-size: 1rem;
          width: 100% !important;
        }
      }
    }
  }

  @media screen and (max-width: 495px) {
    .box-button-fixed {
      .button-comissao {
        .jns-button {
          font-size: 0.875rem;
        }
      }

      .buttons-emissao {
        .jns-button {
          font-size: 0.875rem;
        }
      }
    }
  }

  .border-right {
    border-left: #ddd 2px solid;
    height: 360px;
    margin-left: 2%;
    flex-basis: 2%;
  }

  .headers {
    color: $blueColor;
  }

  .jns-button-color {
    background-color: $blueColor;
  }

  .button_nonactive {
    background-color: $whiteColor;
    color: $blueColor;
  }

  .v-icon {
    font-size: 20px !important;
  }

  .icon_blue {
    color: $blueColor;
    cursor: help;
  }

  .msg-tax {
    width: 42%;
    background-color: $whiteColor;
    color: black;
    position: absolute;
    border-radius: 4px;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    left: 40%;
    top: 8%;
    font-size: 13px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .msg-commission {
    width: 50%;
    background-color: $whiteColor;
    color: black;
    position: absolute;
    border-radius: 4px;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    left: 40%;
    top: 0%;
    font-size: 13px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .hint {
    float: right;
    margin-top: -16px;
    font-size: 10px;
  }

  .v-responsive {
    flex: inherit !important;
  }

  /* Slider */

  .slider {
    height: 100px;
    width: 99%;
    padding-left: 3%;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  .left_ticks {
    height: 25px;
    border-left: 5px dashed red;
    border-bottom: 5px dashed red;
    margin-top: 9px;
    position: absolute;
  }

  .right_ticks[data-v-050ac8bc] {
    height: 22px;
    border-right: 2px solid #b6b6b6;
    float: right;
    margin-top: 11px;
  }

  .left_label {
    position: absolute;
    left: 10px;
    float: left;
    top: 372px;
  }

  .center_label_commission {
    position: absolute;
    text-align: left;
    left: 27%;
    font-size: 13px;
    color: #282498;
    font-weight: bold;
    top: 372px;
  }

  .right_label {
    position: absolute;
    text-align: center;
    left: 43%;
    font-size: 13px;
    top: 372px;
  }

  .read_only {
    background-color: #e6e6e6;
    height: 45px;
    padding-top: 0px;
    margin-top: 16px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .msg_limites {
    background-color: #d21a5e;
    border-radius: 10px;
    padding: 12px;
    color: white;
    font-weight: bold;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/router/views/Propostas/Passos/PremioComissao.vue